<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte/internal'
    import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
    import type { Company } from '../../modules/usersApi/companies/company'
    import ObStep from './ob-step.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    const dispatch = createEventDispatcher()

    let show = false
    let loaded = false
    let planPurchaseId: string = null
    let disabled = false

    const typeOptions = [
        { value: 'trial', label: 'Quero informar depois' },
        { value: 'active', label: 'Quero informar minha chave de ativação' },
    ]

    function onBack() {
        dispatch('back')
    }

    async function onNext() {
        if (show) return
        if (type === 'trial' || disabled) {
            dispatch('next')
            return
        }
        if (await saveEntity()) {
            dispatch('next')
        }
    }

    onMount(async () => {
        await loadEntities()
    })

    async function loadEntities() {
        try {
            show = true
            let result: Company = await window.api.users.companies.getOne(window.store.company.companyId)
            if (result.planPurchaseId) {
                type = 'active'
                disabled = true
            }
            planPurchaseId = result.planPurchaseId
            // importante: essa abordagem abaixo só funciona pois é a primeira etapa. se fosse outra ela impediria de se voltar o assistente.
            if (result.planStatus === 'manual' || result.planStatus === 'free') {
                dispatch('ignore')
            }
            loaded = true
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            planPurchaseId = planPurchaseId.trim()
            if (planPurchaseId.length !== 36) {
                window.error('Informe uma chave válida')
                return
            }
            show = true
            await window.api.users.companies.update(window.store.company.companyId, { planPurchaseId })
            return true
        } catch (error) {
            window.error(error)
            return false
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (!(await updateEntity())) return false
        return true
    }

    let type = 'trial'
</script>

<ObStep title="Ativação da Conta" label="Informe sua chave de ativação ou inicie um teste gratuito.">
    <svelte:fragment slot="acts">
        <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={onBack} />
        <Zbutton color="primary" icon={faAngleRight} label="Avançar" loading={show} disabled={show} on:click={onNext} />
    </svelte:fragment>

    <ZContainer gapRow="8px" gapCol="8px">
        <Zinput size={8} sizeM={12} type="inlineselect_2" options={typeOptions} {disabled} bind:value={type} />
        {#if type === 'active'}
            <Zinput size={8} sizeM={12} label="Chave de ativação" type="text" {disabled} bind:value={planPurchaseId} />
        {/if}
    </ZContainer>
</ObStep>

<LoadSpinner {show} />
